import { render } from "./LabdaqFilter.vue?vue&type=template&id=7ed4cd86"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/navbarFilter/LabdaqFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed4cd86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed4cd86', __exports__)) {
    console.log('reload')
    api.reload('7ed4cd86', __exports__)
  }
  
  module.hot.accept("./LabdaqFilter.vue?vue&type=template&id=7ed4cd86", () => {
    console.log('re-render')
    api.rerender('7ed4cd86', render)
  })

}


export default __exports__